import { createFileRoute } from "@tanstack/react-router";
import { LegalPage, legalHead } from "@/pages/LegalPage";
import { cookiepolitikStrings } from "@/i18n/content/legal";

export const Route = createFileRoute("/de/cookie-und-datenschutzrichtlinie")({
  head: () => legalHead("cookiepolitik", "de", cookiepolitikStrings.de.meta),
  component: () => <LegalPage {...cookiepolitikStrings.de} />,
});
